
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import CompetitorLogo from '@/components/sports/common/CompetitorLogo.vue';

import type { WebLocale } from '@/enums/web-locale';

import { SingleStepSportEvent, SportEventStatus } from '@/@types/graphql-types';
import { EventsEdgeContext, SingleStepContext, contextIs } from '@/helpers/sports/config';
import { OrderedCompetitors } from '@/helpers/sports/config/singleStepContexts';

const Language = namespace('language');

@Component({
	name: 'SingleStepEventCard',
	components: { CompetitorLogo },
})
export default class SingleStepEventCard extends Vue {
	@Prop({ required: true }) event: SingleStepSportEvent;
	@Prop({ default: false }) expandOffers: boolean;
	@Prop({ required: true }) context: SingleStepContext | EventsEdgeContext;

	@Language.State webLocale: WebLocale;

	get node() {
		return this.event ?? {};
	}

	get fullPath() {
		return this.node.content.fullPath;
	}

	get competitors(): OrderedCompetitors {
		if (!contextIs.event(this.context)) {
			return this.context.getCompetitors(this.node, this.webLocale);
		}

		throw Error(`[SingleStepEventCard] does not support page type: ${this.context.pageType}`);
	}

	get startName() {
		return this.competitors.start.map(team => team.name).join(' / ');
	}

	get startCompetitor() {
		return this.competitors.start[0];
	}

	get endName() {
		return this.competitors.end.map(team => team.name).join(' / ');
	}

	get endCompetitor() {
		return this.competitors.end[0];
	}

	get startDateTime() {
		return new Date(this.event.content.startAt) ?? null;
	}

	get isEnded() {
		return this.event.content?.status === SportEventStatus.Closed;
	}
}
